import DoubleCheckedIcon from 'assets/icons/DoubleCheckedIcon'
import { useEffect, useState } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ClipLoader } from 'react-spinners'

import SubTitle from '../components/UI/sub-title/sub-title'
import { useCheckActivationQuery } from '../redux/api/mega-card-activation.api'
import { setError } from '../redux/store/slices/error-slice'
import { mobilePhoneSelector, uuidMegaCardActivationSelector } from '../redux/store/slices/mega-card-activation-slice'
import { Button } from 'components/UI/button/button'
import { pathnames } from 'utils/steps'

function LoadingPage() {
  const { t } = useTranslation('')
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const phoneNumber = useSelector(mobilePhoneSelector)
  const uuidMegaCardActivationApplication = useSelector(uuidMegaCardActivationSelector)
  const [localStatus, setLocalStatus] = useState<string | null>(null)
  const [skip, setSkip] = useState<boolean>(false)
  const { data: status } = useCheckActivationQuery(
    { uuid: uuidMegaCardActivationApplication },
    { pollingInterval: 5000, skip }
  )

  useEffect(() => {
    if (!status?.data?.status) return
    setLocalStatus(status?.data?.status)
  }, [localStatus, navigate, status])

  useEffect(() => {
    if (localStatus === 'CANCELED') {
      const description = status?.data?.reason || t('generic_error', { ns: 'badcases' })
      dispatch(setError({ code: 'ACTIVATION_CANCELED', description }))
      navigate('/error')
    }
    if (localStatus && localStatus !== 'CANCELED' && !status?.data?.pan_card && (status?.data?.reason || status?.error)) {
      const description = status?.data?.reason || t('generic_error', { ns: 'badcases' })
      dispatch(setError({ code: status?.data?.status || 'ERROR', description }))
      navigate('/error')
    }
  }, [dispatch, localStatus, navigate, status?.data?.status, status?.data?.reason, status?.error, t])

  useEffect(() => {
    if (status?.data?.pan_card) {
      setSkip(true)
    }
  }, [status])

  return (
    <>
      <div className='w-full flex flex-col gap-6 items-center justify-center  mt-5 sm:mt-0'>
        {status?.data?.pan_card && <DoubleCheckedIcon />}
        <SubTitle variant='bold'>
          {status?.data?.pan_card
            ? t('finished-title', { ns: 'megaActivationLoading' })
            : t('application-in-progress', { ns: 'megaActivationLoading' })}
        </SubTitle>
        {status?.data?.pan_card ? (
          <>
            <p className='text-lg text-center'>
              {t('finished-text', { phone_number: phoneNumber, ns: 'megaActivationLoading' })}
            </p>
            <Button variant='gradient' onClick={() => navigate(pathnames['personal-cabinet'])}>
              {t('to-personal-cabinet', { ns: 'megaActivationLoading' })}
            </Button>
          </>
        ) : (
          <ClipLoader color={'green'} />
        )}
      </div>
    </>
  )
}

export default LoadingPage
